import React, { Component } from 'react'
import 'react-vis/dist/style.css'
import { OrdinalFrame } from 'semiotic'
import * as moment from 'moment'
import { withStyles } from 'material-ui/styles'
import IconButton from 'material-ui/IconButton'
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'
import { Button, Grid } from 'material-ui'

const axis = {
  orient: 'left',
  tickFormat: d => (
    <text
      key={`tick-${d}`}
      style={{ fill: '#cecece', textAnchor: 'end', fontSize: 10 }}
      y={-2}
    >
      {d}
    </text>
  ),
  tickValues: [],
  baseline: false,
  tickLineGenerator: ({ xy }) => (
    <path
      key={`tickLine-${xy.value}`}
      style={{ stroke: '#F0F0F0 ' }}
      d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${xy.y1}L${xy.x1},${
        xy.y1
      }Z`}
    />
  )
}

const styles = theme => ({
  tooltipContent: {
    background: 'white',
    border: 1,
    color: 'black',
    padding: 10
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  }
})

@withStyles(styles)
export default class AlchemyReadingCalendar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dateSeleted: new Date(moment())
        .toISOString('yyyy-MM-dd')
        .substring(0, 10),
      weekNo: moment()
        .week()
        .toString(),
      yearmonthNo: moment()
        .endOf('month')
        .format('l')
    }
    this.nextMonth = this.nextMonth.bind(this)
    this.prevMonth = this.prevMonth.bind(this)
    this.setToday = this.setToday.bind(this)
  }

  hoursBar = ({ data, rScale, adjustedSize, margin }) => {
    const renderedPieces = []

    const keys = Object.keys(data)

    keys.forEach(key => {
      //Only one piece of data per column though we'll render multiple graphical elements
      const column = data[key]

      //You can return an array of graphics or an array of objects with extra data (see the Waterfall chart demo)
      const markObject = (
        <g key={`piece-${key}`}>
          {column.pieceData.map(
            (piece, index) =>
              moment(piece.data.date, 'l') >
              moment(moment().format('l'), 'l') ? (
                <g key={`g-future-days-${index}-${key}`}>
                  <rect
                    key={`rect-${index}-${key}`}
                    fill={'rgba(0, 0, 0, 0.05)'}
                    opacity={0.5}
                    width={column.width}
                    height={column.width}
                    x={column.x}
                    y={piece.scaledVerticalValue}
                    rx={3}
                    ry={3}
                  />
                </g>
              ) : !piece.data.durationMin ? (
                <g
                  key={`g-${index}-${key}`}
                  cursor={!this.props.shared ? 'pointer' : 'auto'}
                  onClick={
                    this.props.action === ''
                      ? () => {
                          console.log('action to add')
                        }
                      : () => {
                          this.props.action(piece.data.date, 'add')
                        }
                  }
                >
                  <rect
                    key={`rect-${index}-${key}`}
                    fill={
                      piece.data.log === 'grey'
                        ? 'white'
                        : piece.data.durationMin === 0
                          ? moment(piece.data.date, 'l') >
                            moment(moment().format('l'), 'l')
                            ? 'rgba(0, 0, 0, 0.05)'
                            : 'rgba(0, 0, 0, 0.15)'
                          : '#d2c3ff'
                    }
                    stroke={
                      moment(new Date(piece.data.date)).format('l') ===
                      moment().format('l')
                        ? 'green'
                        : ''
                    }
                    opacity={0.5}
                    width={column.width}
                    height={column.width}
                    x={column.x}
                    y={piece.scaledVerticalValue}
                    rx={3}
                    ry={3}
                  />
                  {!this.props.shared && (
                    <text
                      key={`text-all-trackers-add-btn-${key}}`}
                      x={column.x + column.width / 2 - adjustedSize[0] / 42}
                      y={piece.scaledVerticalValue + adjustedSize[0] / 14.6}
                      fontSize={adjustedSize[0] / 12}
                      fill={'rgba(255, 255, 255, 0.92)'}
                      fontWeight={100}
                    >
                      +
                    </text>
                  )}
                </g>
              ) : (
                <g
                  key={`g-${index}-${key}`}
                  cursor={'pointer'}
                  onClick={
                    this.props.action === ''
                      ? () => {
                          console.log('action to add')
                        }
                      : () => {
                          this.props.action(piece.data.date, 'other')
                        }
                  }
                >
                  <rect
                    key={`rect-${index}-${key}`}
                    fill={
                      piece.data.log === 'grey'
                        ? 'white'
                        : piece.data.durationMin === 0
                          ? moment(piece.data.date, 'l') >
                            moment(moment().format('l'), 'l')
                            ? 'rgba(0, 0, 0, 0.05)'
                            : 'rgba(0, 0, 0, 0.15)'
                          : '#d2c3ff'
                    }
                    stroke={
                      moment(new Date(piece.data.date)).format('l') ===
                      moment().format('l')
                        ? 'green'
                        : ''
                    }
                    opacity={0.5}
                    width={column.width}
                    height={column.width}
                    x={column.x}
                    y={piece.scaledVerticalValue}
                    rx={3}
                    ry={3}
                  />
                  {!piece.data.durationMin &&
                  moment(piece.data.date, 'l') <=
                    moment(moment().format('l'), 'l') ? (
                    <text
                      key={`text-all-trackers-add-btn-${key}}`}
                      x={column.x + column.width / 2 - adjustedSize[0] / 42}
                      y={piece.scaledVerticalValue + adjustedSize[0] / 14.6}
                      fontSize={adjustedSize[0] / 12}
                      fill={'rgba(255, 255, 255, 0.92)'}
                      fontWeight={100}
                    >
                      +
                    </text>
                  ) : this.props.type ? (
                    this.props.type === 'sleepTracker' ? (
                      moment(
                        moment(new Date(piece.data.durationMin)).format(
                          'HH:mm'
                        ),
                        'HH:mm'
                      ) <= moment('06:00', 'HH:mm') ? (
                        <text
                          key={`text-sleepTracker-star-${key}`}
                          x={column.x + column.width / 2 - adjustedSize[0] / 32}
                          y={piece.scaledVerticalValue + adjustedSize[0] / 16}
                          fontSize={adjustedSize[0] / 16}
                          fill={
                            moment(
                              moment(new Date(piece.data.durationMin)).format(
                                'HH:mm'
                              ),
                              'HH:mm'
                            ) <= moment(this.props.goal.timeCompleteTo, 'HH:mm')
                              ? 'yellow'
                              : 'white'
                          }
                        >
                          {piece.data.durationMin === 'error' ? '?' : '★'}
                        </text>
                      ) : (
                        <text
                          key={`text-sleepTracker-non-star-${key}`}
                          x={column.x + column.width / 2 - adjustedSize[0] / 66}
                          y={piece.scaledVerticalValue + adjustedSize[0] / 18}
                          fontSize={adjustedSize[0] / 22}
                          fill={'yellow'}
                        >
                          {piece.data.durationMin === 'error' ? '?' : ''}
                        </text>
                      )
                    ) : this.props.type === 'readingTracker' ? (
                      piece.data.pagesRead >= this.props.goal.pagesGoalLow && (
                        <text
                          key={`text-readingTracker-star-${key}`}
                          x={column.x + column.width / 2 - adjustedSize[0] / 32}
                          y={piece.scaledVerticalValue + adjustedSize[0] / 16}
                          fontSize={adjustedSize[0] / 16}
                          fill={
                            piece.data.pagesRead >=
                            this.props.goal.pagesGoalHigh
                              ? piece.data.pagesRead >=
                                this.props.goal.pagesGoalSuperHigh
                                ? 'papayawhip'
                                : 'yellow'
                              : 'white'
                          }
                        >
                          ★
                        </text>
                      )
                    ) : (
                      <text key={`text-non-sleepTrackers-${key}`} />
                    )
                  ) : piece.data.durationMin >= 30 ? (
                    <text
                      key={`text-tracker-type-unknown-star-${key}`}
                      x={column.x + column.width / 2 - adjustedSize[0] / 32}
                      y={piece.scaledVerticalValue + adjustedSize[0] / 16}
                      fontSize={adjustedSize[0] / 16}
                      fill={'white'}
                    >
                      ★
                    </text>
                  ) : (
                    <text key={`text-tracker-type-unknown-non-star-${key}`} />
                  )}
                </g>
              )
          )}
          }
        </g>
      )

      renderedPieces.push(markObject)
    })
    return renderedPieces
  }

  setToday = () => {
    this.setState({
      yearmonthNo: moment()
        .endOf('month')
        .format('l')
    })
  }

  prevMonth = () => {
    const prevYearMonthNo = moment(new Date(this.state.yearmonthNo))
      .subtract(1, 'M')
      .endOf('month')
      .format('l')
    this.setState({ yearmonthNo: prevYearMonthNo })
  }

  nextMonth = () => {
    const prevYearMonthNo = moment(new Date(this.state.yearmonthNo))
      .add(1, 'M')
      .endOf('month')
      .format('l')
    this.setState({ yearmonthNo: prevYearMonthNo })
  }

  addBlankDate = data => {
    var iDateStart = moment(new Date(this.state.yearmonthNo)).startOf('month')
    var iDateEnd = moment(new Date(this.state.yearmonthNo)).endOf('month')
    var daysMonth = iDateEnd.diff(iDateStart, 'days') + 1

    for (var i = 0; i < daysMonth; i++) {
      var blankDate = iDateStart
      var isSame = false

      for (var j in data) {
        if (
          moment(new Date(data[j].date)).format('l') === blankDate.format('l')
        ) {
          isSame = true
        }
      }
      if (!isSame) {
        data.splice(i, 0, {
          date: blankDate.format('l'),
          week: blankDate.week(),
          durationMin: 0,
          pagesRead: 0,
          log: 'blank'
        })
        isSame = false
      }

      iDateStart = moment(blankDate).add(1, 'd')
    }

    var weekCalStart = moment(new Date(this.state.yearmonthNo))
      .startOf('month')
      .week()
    for (i in data) {
      data[i].week = data[i].week - weekCalStart
      if (data[i].week < 0) {
        data[i].week += 52
      }
      data[i]['weekday'] = moment(new Date(data[i].date)).weekday()
    }
    var firstDate = moment(new Date(this.state.yearmonthNo)).startOf('month')
    var addPrevDays = firstDate.weekday()
    var blankDatePrev = firstDate
    for (i = 0; i < addPrevDays; i++) {
      blankDatePrev = blankDatePrev.subtract(1, 'd')

      data.splice(0, 0, {
        date: blankDatePrev.format('l'),
        week: blankDatePrev.week() - weekCalStart,
        durationMin: 0,
        pagesRead: 0,
        log: 'grey',
        weekday: blankDatePrev.weekday()
      })
    }

    return data
  }

  render() {
    if (this.props.data && this.props.data.loading) {
      return <div>Loading</div>
    }

    if (this.props.data && this.props.data.error) {
      return <div>Error</div>
    }

    const { classes } = this.props

    const dataCCHours = this.props.data.filter(
      work =>
        moment(new Date(work[0]))
          .endOf('month')
          .format('l') === this.state.yearmonthNo
    )

    let dataCal = []
    const keys = Object.keys(dataCCHours)
    keys.forEach((key, index) => {
      const eachDay = dataCCHours[key]
      const weekNo = moment(new Date(eachDay[0])).week()
      dataCal.splice(index, 0, {
        date: eachDay[0],
        week: weekNo,
        durationMin: eachDay[2],
        pagesRead: eachDay[3],
        log: ''
      })
    })

    dataCal = this.addBlankDate(dataCal)

    return (
      <div>
        <div
          id="switch-months"
          style={{
            width: '70%',
            marginLeft: '15%',
            marginRight: '15%'
          }}
        >
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="baseline"
            spacing={0}
          >
            <Grid item xs={2} />
            <Grid item xs={2}>
              <IconButton
                onClick={() => this.prevMonth()}
                disabled={this.state.isPaused}
                className="btn btn-default btn-style"
              >
                <ChevronLeftIcon style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item xs={4}>
              <span style={{ fontSize: 15 }}>
                {moment(new Date(this.state.yearmonthNo)).format('MMM YYYY')}
              </span>
            </Grid>
            <Grid item xs={2}>
              <IconButton
                onClick={() => this.nextMonth()}
                disabled={this.state.isPaused}
                className="btn btn-default btn-style"
              >
                <ChevronRightIcon style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item xs={2}>
              {moment(new Date(this.state.yearmonthNo)).format('MMM YYYY') ===
              moment().format('MMM YYYY') ? (
                ''
              ) : (
                <Button
                  onClick={() => this.setToday()}
                  className={classes.icon}
                  size="small"
                >
                  <span style={{ fontSize: 10 }}>Today</span>
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
        <div
          id="calendar_view_chart"
          style={{
            position: 'relative',
            textAlign: 'center',
            marginLeft:
              -this.props.width * 0.07 +
              (window.innerWidth - this.props.width / 1.28) / 2
          }}
        >
          <OrdinalFrame
            size={[this.props.width / 1.28, this.props.height / 1.28]}
            data={dataCal}
            type={{
              type: this.hoursBar,
              rotate: 180
            }}
            rAccessor={d => d.week}
            oAccessor={d => moment(new Date(d.date)).format('d')}
            sortO={(a, b) => a > b}
            rExtent={[0, 5]}
            projection="vertical"
            oPadding={this.props.width / 28}
            margin={{
              left: this.props.width / 10.5,
              top: this.props.height / 24,
              right: this.props.width / 10.5,
              bottom: this.props.height / 9.6
            }}
            axis={axis}
            invertR={true}
            oLabel={d => (
              <text
                key={`label-${d}`}
                y={-this.props.height / 1.48}
                fill="#cecece"
                textAnchor="middle"
                fontSize={14}
              >
                {d === '0'
                  ? 'S'
                  : d === '1'
                    ? 'M'
                    : d === '2'
                      ? 'T'
                      : d === '3'
                        ? 'W'
                        : d === '4' ? 'T' : d === '5' ? 'F' : 'S'}
              </text>
            )}
            hoverAnnotation={false}
            annotationSettings={{
              layout: {
                type: 'marginalia',
                orient: 'right',
                textPadding: this.props.width / 21
              }
            }}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartTypes/AlchemyReadingCalendar.js